import type { EvalFinding, EvalMark, PointBox } from "../eval-runs-data"

/** What the reader has chosen on the page: an expert mark, one of our findings, or nothing. */
export type Selection = { kind: "mark"; id: string } | { kind: "finding"; id: number } | null

/** Where the selected box is: its page and its rectangle in PDF points. */
export function anchorOf(
  selection: Selection,
  marks: readonly EvalMark[],
  findings: readonly EvalFinding[],
): { page: number; box: PointBox } | null {
  if (selection?.kind === "mark") {
    const mark = marks.find((m) => m.id === selection.id)
    return mark?.rect ? { page: mark.page, box: mark.rect } : null
  }
  if (selection?.kind === "finding") {
    const first = findings.find((f) => f.id === selection.id)?.boxes[0]
    return first ? { page: first.page, box: first.bbox } : null
  }
  return null
}
